import { render, staticRenderFns } from "./FinishFormBrakeMetalsCatalog.vue?vue&type=template&id=7de7dd66&"
import script from "./FinishFormBrakeMetalsCatalog.vue?vue&type=script&lang=js&"
export * from "./FinishFormBrakeMetalsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports